import { render } from "./PlayGameView.vue?vue&type=template&id=d8d1789e"
import script from "./PlayGameView.vue?vue&type=script&lang=js"
export * from "./PlayGameView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__